import { connect } from 'react-redux';
import { searchFood } from 'features/nutrition/ducks/nutritionActions';
import React from 'react';
import Loader from 'features/Loader/Loader';
import AddIngredientList from './AddIngredientList';
import IngredientSearch from './IngredientSearch';

class IngredientContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ''
    };
  }

  handleChange(e) {
    this.props.searchFood(e.target.value, this.props.trainer.id);
    this.setState({ search: e.target.value });
  }

  render() {
    const { food, handleSelectIngredient, handleCreateNewFood } = this.props;

    return (
      <div className="ingredient-content">
        {food.loadingFood ? (
          <Loader />
        ) : (
          <AddIngredientList
            commonList={food.search.common}
            brandedList={food.search.branded}
            yourFoodList={food.search.your_food}
            handleSelectIngredient={handleSelectIngredient}
            isInitial={this.state.search === ''}
          />
        )}
        <IngredientSearch
          handleChange={this.handleChange.bind(this)}
          handleCreateNewFood={handleCreateNewFood}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    food: state.nutritionReducer.food,
    trainer: state.trainerProfileReducer.trainer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    searchFood: (query, trainerUid) => dispatch(searchFood(query, trainerUid))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(IngredientContent);
